import { z } from 'zod';

import { IBaseEntity } from './base-entity.interface';
import { Organization, OrganizationId } from './organization.interface';
import { Subscription } from './subscription';

export const OrganizationUsageIdSchema = z.string().brand('OrganizationUsageId');
export type OrganizationUsageId = z.infer<typeof OrganizationUsageIdSchema> | string;

/**
 * A usage of an organization.
 */
export interface OrganizationUsage extends IBaseEntity {
    id: OrganizationUsageId;
    organizationId: OrganizationId;
    creditsUsed: number;
    periodStart: Date;
    periodEnd: Date;
    organization: Organization;
    subscription: Subscription;
}
